import { useEffect, useRef, useState } from "react";


function Header({ isOpen, oppKDName, war_data }) {
    const [showBackdrop, setShowBackdrop] = useState(false);
    const topDrawer = useRef(null);
    let userType = localStorage.getItem("user_type");
    const defaultTopDrawer = (flag) => {
        if (flag === true && isOpen === true) {
            const timer = setTimeout(() => {
                if (topDrawer.current) {
                    topDrawer.current.style.transform = 'translateY(0)';
                }
            }, 1000);
            return () => clearTimeout(timer);
        }
    }
    useEffect(() => {
        if (userType === 'rm' || userType === 'admins') {
            defaultTopDrawer(war_data.show_brahmastra_ani_rm);
        } else {
            // console.log('is open', isOpen);
            defaultTopDrawer(war_data.show_brahmastra_ani);
        }
    }, [war_data, userType]);
    useEffect(() => {
        if (!isOpen) {
            topDrawer.current.style.transform = 'translateY(-100%)';
        }
    }, [isOpen]);

    const [isDrawerOpen, setIsDrawerOpen] = useState(false);

    const handleHeaderClick = () => {
        // if (isOpen === false) {
        //     setIsDrawerOpen(true);
        // }
        // setIsDrawerOpen(prevState => !prevState);
        setIsDrawerOpen((prevState) => {
            const newDrawerState = !prevState;

            // Toggle backdrop visibility when drawer state changes
            setShowBackdrop(newDrawerState);

            return newDrawerState;
        });
    };

    const handleInsideHeaderClick = () => {
        setIsDrawerOpen(false);
        setShowBackdrop(false);
    };

    const [text, setText] = useState(null);
    const [showNewText, setShowNewText] = useState(false); // To control the fade effect

    useEffect(() => {
        setText(<span className="total-brahma-text">{String(war_data.opp_brahmastra_added)} New Bhramsatra Added </span>);
        const timer = setTimeout(() => {
            setShowNewText(true); // Trigger fade-in animation
            setText(<span className="total-brahma-text">Region's Total Brahmastra <br /><span className="total-bpoints">{war_data.opp_kd_brahmastra}</span></span>);
        }, 6000);
        return () => clearTimeout(timer);
    }, [war_data]);
    return (
        <>
         {showBackdrop && (
                <div
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        backgroundColor: 'rgba(0, 0, 0, 0.7)',
                        zIndex: 100,
                    }}
                    onClick={() => {
                        setIsDrawerOpen(false);
                        setShowBackdrop(false);
                    }}
                ></div>
            )}
            <header id="headerDrawerToggle" onClick={handleHeaderClick}>
                <div className="outercontainer">
                    <p className="teamname">{oppKDName}</p>

                    <div ref={topDrawer} className="drawer top-drawer" style={{ transform: 'translateY(-100%)' }}>
                        <footer id="drawerHeaderTop">
                            <div className="outercontainer">
                                <p className="teamnamef">{oppKDName}</p>
                            </div>
                        </footer>
                        <div className="points-box-top rmpb-top">
                            {
                                (userType === 'rm' || userType === 'admins') ?
                                <div>
                                    <p>Points added in last {war_data.rm_time}</p>
                                    <p>{war_data.opp_pts_added}</p>
                                    <p>Brahmastra completed : {war_data.opp_brahmastra_added_rm}</p>
                                </div> :
                                <>
                                    {/* <h1 style={{"color" : "white"}}>Distributor code goes here!!</h1> */}
                                    <div className="outerbhram-container">
                                        <div className="bhram-box animate-left">
                                            <img src="../images/BOR/bhramsatra-big.png" className="img-fluid bhramstone-big"></img>
                                        </div>
                                        <div className="bhram-points-box animate-right">
                                          <span className={` ${showNewText ? "fade-in-bottom" : ""}`}>{text}</span>
                                        </div>
                                    </div>
                                </>
                            }
                            
                        </div>
                    </div>
                </div>
            </header>


            <div className="topHeaderDrawerBox">
                <div className={`top-drawer-click ${isDrawerOpen ? 'show' : ''}`}>

                    <div className="pointcompltebox">
                        <p>Brahmastra completed : {war_data.opp_kd_brahmastra}</p>
                    </div>
                    <header id="headerDrawerInisdeToggle" onClick={handleInsideHeaderClick}>
                        <p className="teamname">{oppKDName}</p>
                    </header>
                </div>
            </div>
            <div className={`backdrop ${isDrawerOpen ? 'show' : ''}`} />
        </>
    );
}

export default Header;